module.exports = __webpack_public_path__ + "static/media/slide-1.b052927a.webp";